import request from '@/utils/request'
import md5 from 'md5'
import {getMember} from '@/utils/auth';
import router from '@/router'

const API_METHODS = {
  /**
   * 通用接口
   **/
  send_sms: `/oapi/v1/send_sms`,                      // 请求短信验证码
  /**
   * 会员相关接口
   **/
  smsLogin: `/oapi/v1/member/sms_login`,              // 短信登录
  logout: `/oapi/v1/member/logout`,                   // 登出
  getUserData: `/oapi/v1/member/detail`,              // 获取会员信息
  /**
   * 视频相关接口
   **/
  getVideoCourseList: `/oapi/v1/video/course/list `,  // 视频课程列表接口
  getVideoDetail: `/oapi/v1/video/course/read `,      // 视频课程详情接口
  getVideoURL: `/oapi/v1/video/url `,                 // 获取视频播放地址
  getVideoLog: `/oapi/v1/video/course/record/list`,   // 我的视频课程
  addVideoLog: `/oapi/v1/video/course/record/add`,    // 增加视频观看记录
  /**
   * 考试专题相关接口
   **/
  getExamList: `/oapi/v1/exam/list `,                 // 考试专题列表接口
  getExamDetail: `/oapi/v1/exam/read `,               // 考试专题详情接口
  getExamInfo: `/oapi/v1/exam/info `,                 // 获取考试试题接口
  getExamLog: `/oapi/v1/my/exam/list`,                // 我的考试专题
  inputExamInfo: `/oapi/v1/exam/input `,              // 提交考试试题答案
  getExamResult: `/oapi/v1/my/exam/read `,            // 读取考试详情
};

/**
 * 通用接口
 * @method          请求接口
 * @params          请求参数
 * @needLogin       是否需要登录状态（如果为ture，会自动补齐user_tid参数）
 * @autoChooseShop  是否需要自动填充门店TID（如果为ture，会自动补齐shop_tid参数）
 * @filePath        上传文件路径
 * 备注：member_tid和shop_tid由该接口自动填充，无需手动填写这两个参数
 */
export function APIRequest(method, params = {}, needLogin = false) {
  /*** 设置相关签名信息 ***/
  // 签名参数配置
  params.sign_platform_type = "2";
  params.sign_public_token = "9k*hz1L8TPVgKLN#3n!RTf*hj4fB8qkBZqs8h3FHgDapJWkrd$";
  params.sign_request_time = Date.parse(new Date()) / 1000;
  params.sign_equipment_sn = 'qwertipljdasdasjdhasjhduihuhufhgaf';
  params.xcx_version = '1.0.0';

  if (needLogin) { // 判断是否需要登录态
    let memberInfo = getMember();
    if (memberInfo) { // 判断会员是否登录
      if (memberInfo.tid > 0 && memberInfo.token) { // 判断用户是否已经绑定手机号码
        // 用户已经登录和绑定手机号码，自动填充用户tid和用户授权token
        params.member_tid = memberInfo.tid;
        params.sign_private_token = memberInfo.token;
      }
    } else {
      // 用户未授权，提示用户去授权
      router.push({ 'path': '/login' });
      return Promise.reject();
    }
  }
  // 签名加密计算
  let keys = Object.keys(params).sort();
  let sign_token = [];
  for (let key in keys) {
    let param_key = keys[key];
    let param_value = params[param_key];
    if (param_value !== undefined) {
      if (param_value instanceof Object || param_value instanceof Array) {
        //sign_token.push(param_key + '=' + JSON.stringify(params) );
      } else {
        sign_token.push(param_key + '=' + param_value.toString());
      }
    }
  }
  sign_token = sign_token.join("&");
  sign_token = md5(sign_token);
  params.sign_token = sign_token;
  // 删除多余字段
  delete params.sign_public_token;
  delete params.sign_private_token;

  // 构建网络数据请求
  return request({
    url: API_METHODS[method],
    method: 'post',
    data: params
  });
}



// WEBPACK FOOTER //
// ./src/api/api.js